import React, { useState } from 'react';
import {
  Container, Input, Label, RadioContent,
} from './styles';

const Radio = ({
  name, value, checked, label, onChange,
}) => (
  <RadioContent>
    <Input
      type="radio"
      checked={checked}
      value={value}
      id={value}
      name={name}
      onChange={onChange}
    />
    <Label className="radio__label" htmlFor={value}>
      {label}
    </Label>
  </RadioContent>
);

const RadioGroup = ({
  defaultValue, options, name, onChange,
}) => {
  const [checked, setChecked] = useState(defaultValue || '');

  const handleChange = (e) => {
    const { name: nameTarget, value } = e.target;
    setChecked(value);
    onChange(nameTarget, value);
  };

  return (
    <Container>
      {options.map(option => (
        <Radio
          key={option.value}
          value={option.value}
          label={option.label}
          checked={checked === option.value}
          name={name}
          onChange={handleChange}
        />
      ))}
    </Container>
  );
};

export default RadioGroup;
